import { DiscordImg } from "app/constants";

const GithubIcon = () => {
  return <img width="24" height="24" src={DiscordImg} alt="Coingecko-icon" />;
};

export default GithubIcon;
